import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/landing/household.svg")